import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-delete-phone-number-dialog',
    styleUrls: ['./delete-phone-number-dialog.component.scss'],
    templateUrl: './delete-phone-number-dialog.component.html',
    standalone: false
})
export class DeletePhoneNumberDialogComponent {
   phoneExtensionList: any = [];
   faxExtensionList: any = [];

    form: any;

   constructor(
      private dialogRef: MatDialogRef<DeletePhoneNumberDialogComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.phoneExtensionList = data.phoneExtensionList;
      this.faxExtensionList = data.faxExtensionList;
   }

   onConfirm(): void {
      this.dialogRef.close(true);
   }

   onCancel(): void {
      this.dialogRef.close(false);
   }
}
